// import React from 'react';

//image size should be 1200 × 661

import { srAudioFeedbackImg, srDatePickerImg, srLinkedSliderImg, srSemanticImg } from "../img/projImgsObj.js";

const surveyRedesignProject = {
  title: "Survey Redesign",
  shortTitle: "surveyredesign",
  description:
    "Implementation of a modernized design for Tivian's survey technology.",
  heroImage: srAudioFeedbackImg,
  previewImg: srAudioFeedbackImg,
  skills: ["CSS3", "SCSS", "PHP"],
  introText: [
    {
      index: 0,
      text: "Tivian has powerful survey technology, but the design hadn't been updated in some time. I worked with the Product team, Engineering, and a Lead Designer to implement a modernized, user-friendly update to survey question types.",
    },
    {
      index: 1,
      text: "This project required extensive use of CSS, SCSS, an understanding of the php backend, and Tivian's .tpl survey templates.",
    },
  ],
  imgsParas: [
    {
      index: 0,
      img: srSemanticImg,
      text: "Many question types have complex layouts, which required careful consideration of how to approach the responsive design aspects. We often had separate templates for mobile and desktop display of these more complex question types."
    },
    {
      index: 1,
      img: srDatePickerImg,
      text: "For browsers that allow it, we created a custom date picker, with colors that could be configured to a client's branding."    
    },
    {
      index: 2,
      img: srLinkedSliderImg,
      text: "The slider-type questions required some careful use of Flexbox to space elements in a responsive and user-friendly layout.",
    },
  ],
  optstyles: "dropshadow",
};

export default surveyRedesignProject;
